export const ID_ME_BRAND_COLOR = '#0B4C23';
